











import { Component, Vue } from 'vue-property-decorator';

import Container from '@/components/layout/Container.vue';
import SectionCard from '@/components/landing/SectionCard.vue';
import ThumbGallerySlides from '@/components/landing/ThumbGallerySlides.vue';
import PlayButton from '@/components/PlayButton.vue';

import { addGtmEvent, GTMEvent } from '@/helpers/gtm';

import * as SLIDES from '@/config/slides';

@Component({
  components: { Container, SectionCard, PlayButton, ThumbGallerySlides },
})
export default class PreviewSection extends Vue {
  get slides(): SlidesByApp {
    return SLIDES as SlidesByApp;
  }

  get localeSlides() {
    const { locale } = this.$i18n;

    const { en: defaultSlides } = this.slides;

    return this.slides[locale] || defaultSlides;
  }

  get appSlides() {
    if (this.$appName === undefined) {
      return {};
    }
    return this.localeSlides[this.$appName];
  }

  handlePlayClick() {
    addGtmEvent(GTMEvent.LANDING_CLICK);
  }
}
